import React, { Dispatch, SetStateAction, useContext } from 'react';

import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

interface DataValidationsSectionProps {
  validationStatus: any;
}

const DataValidationsSection: React.FunctionComponent<DataValidationsSectionProps> = (props) => {
  let { validationStatus } = props;

  let { chillerLog, chillerLogPhotos } = useContext(ChillerLogsContext);

  const formCompleted = () => {
    return (
      validationStatus === 'complete' &&
      chillerLog?.internal_comment &&
      chillerLog?.internal_comment?.length > 0 &&
      chillerLog?.customer_comment &&
      chillerLog?.customer_comment?.length > 0 &&
      chillerLogPhotos?.length !== 0
    );
  };

  const errorCells = document.querySelectorAll('.error-cell');

  return (
    chillerLog.id && (
      <Grid container>
        <Grid item xs={12} style={{ marginTop: 20 }} className="no-print">
          {formCompleted() ? (
            <Card
              style={{
                background: '#2E7D32',
                color: 'white',
                padding: 10,
                borderRadius: 8,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <CardContent>
                <Typography variant="h6">✅ Data Validations Complete</Typography>
                <Typography variant="body2">All data is correctly filled and within acceptable thresholds.</Typography>
              </CardContent>
            </Card>
          ) : (
            <Card
              style={{
                background: '#EF5350',
                color: 'white',
                padding: 10,
                borderRadius: 8,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <CardContent>
                <Typography variant="h6">⚠️ Data Validations Warning</Typography>
                <Typography variant="body2">
                  Some data is missing or outside expected thresholds, please review the following errors:
                </Typography>
                <>
                  <ul>
                    <>
                      {(chillerLog?.customer_comment === null || chillerLog?.customer_comment?.length === 0) && (
                        <li>Customer comments are blank</li>
                      )}
                      {(chillerLog?.internal_comment === null || chillerLog?.internal_comment?.length === 0) && (
                        <li>TUDI Private comments are blank</li>
                      )}
                      {chillerLogPhotos?.length === 0 && <li>No photos have been uploaded</li>}
                      {errorCells.length > 0 && (
                        <li>{`Log sheet has ${errorCells.length} field(s) outside of threshold`}</li>
                      )}
                    </>
                  </ul>
                </>
              </CardContent>
            </Card>
          )}
        </Grid>
      </Grid>
    )
  );
};

export default DataValidationsSection;
